import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class BreakpointService {
    private _current!: string;
    public get current(): string {
        return this._current;
    }
    public set current(v: string) {
        this._current = v;
    }

    public isMobile(): boolean {
        return this.current == 'sm' || this.current === 'xs';
    }
}
